const API_END_POINTS = {
  GET_PRODUCER: 'producers/{id}',
  GET_PICKUPS_DAYS: 'producers/distinct-shipping-dates',
  GET_PICKUPS_LOCATIONS: 'orders/pickup/locations',
  GET_PICKUPS_ORDERS: 'orders',
  GET_PICKUPS_ORDER: 'orders/{id}',
};

export default API_END_POINTS;
